import { render, staticRenderFns } from "./Acerca.vue?vue&type=template&id=c6f17252"
import script from "./Acerca.vue?vue&type=script&lang=js"
export * from "./Acerca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports